module.exports = __webpack_public_path__ + "img/angry.1c0ad48e.svg";